// extracted by mini-css-extract-plugin
module.exports = {"content":"sso-modal_content__3EuHv"};